import './App.css';
import AppRoutes from './routes';
import DomoticChatbot from './Components/IA/Chatbot-v1';
import { BrowserRouter as Router, useNavigate } from 'react-router-dom';
import { useEffect } from 'react';

// Componente wrapper para la navegación del chatbot
function ChatbotWithNavigation() {
  const navigate = useNavigate();
  
  const handleChatbotNavigate = (route) => {
    console.log('🔗 Chatbot navegando a:', route);
    navigate(route);
  };

  // Debug para verificar que el componente se monta
  useEffect(() => {
    console.log('✅ ChatbotWithNavigation montado correctamente');
  }, []);

  return <DomoticChatbot onNavigate={handleChatbotNavigate} />;
}

function App() {
  // Debug para verificar que App se monta
  useEffect(() => {
    console.log('✅ App montada correctamente');
    console.log('🔄 Verificando rutas...');
  }, []);

  return (
    <Router>
      <div className="App">
        {/* Routes maneja todas las páginas: Home, Servicios, Productos, etc. */}
        <AppRoutes />
        
        {/* Chatbot con capacidad de navegación - disponible en toda la app */}
        <ChatbotWithNavigation />
        
        {/* Debug visual */}
        <div style={{
          position: 'fixed',
          top: '10px',
          left: '10px',
          background: 'green',
          color: 'white',
          padding: '5px 10px',
          borderRadius: '5px',
          fontSize: '12px',
          zIndex: 10001
        }}>
          ✅ App Cargada
        </div>
      </div>
    </Router>
  );
}

export default App;